import { useEffect, useMemo, useState } from "react";
import type { AdminQuizItem } from "../../../shared/types";
import { AtlShell, AtlSearch, QuizMark, StatusChip, ATL_ANS } from "../../components/atelier";
import { api } from "../../api";

function fmtDate(ms: number): string {
  return new Date(ms).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export default function AllQuizzes() {
  const [quizzes, setQuizzes] = useState<AdminQuizItem[] | null>(null);
  const [query, setQuery] = useState("");

  function load() {
    setQuizzes(null);
    api.listAllQuizzes().then((r) => setQuizzes(r.quizzes)).catch(() => setQuizzes([]));
  }
  useEffect(load, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return quizzes ?? [];
    return (quizzes ?? []).filter(
      (x) => x.title.toLowerCase().includes(q) || x.ownerName.toLowerCase().includes(q),
    );
  }, [quizzes, query]);

  const liveCount = (quizzes ?? []).filter((q) => q.live).length;

  return (
    <AtlShell active="All Quizzes" title="All Quizzes" sub="EVERY QUIZ ACROSS ALL ACCOUNTS">
      <div style={{ padding: 30, display: "flex", flexDirection: "column", gap: 16, maxWidth: 1000 }}>
        <div className="atl-card" style={{ padding: 20 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16, flexWrap: "wrap", rowGap: 10 }}>
            <div style={{ flex: "1 1 180px" }}>
              <h3 className="atl-serif" style={{ fontSize: 19 }}>
                Quizzes {quizzes ? <span style={{ color: "var(--atl-faint)" }}>({quizzes.length})</span> : ""}
              </h3>
              <p style={{ fontSize: 13, color: "var(--atl-soft)", fontWeight: 500, marginTop: 2 }}>
                Live &amp; binned, every owner.{liveCount > 0 ? ` ${liveCount} hosting now.` : ""}
              </p>
            </div>
            <AtlSearch placeholder="Search title or owner…" value={query} onChange={setQuery} w={260} />
          </div>

          {quizzes === null ? (
            <p style={{ fontSize: 13, color: "var(--atl-faint)", fontWeight: 500 }}>Loading…</p>
          ) : filtered.length === 0 ? (
            <p style={{ fontSize: 13, color: "var(--atl-faint)", fontWeight: 500 }}>No quizzes found.</p>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {filtered.map((q, i) => (
                <div key={q.id} className="atl-row" style={{ padding: "11px 14px", alignItems: "center", gap: 13, opacity: q.deleted ? 0.6 : 1 }}>
                  <QuizMark c={ATL_ANS[i % ATL_ANS.length]} size={40} emoji={q.coverEmoji} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 14.5, overflowWrap: "anywhere" }}>
                      {q.title}
                      {q.deleted && <span style={{ fontSize: 12, color: "var(--atl-faint)", fontWeight: 500 }}> · in bin</span>}
                    </div>
                    <div style={{ fontSize: 12.5, color: "var(--atl-faint)", fontWeight: 500 }}>
                      {q.ownerName} · {q.questionCount} question{q.questionCount === 1 ? "" : "s"} · updated {fmtDate(q.updatedAt)}
                    </div>
                  </div>
                  {q.live && (
                    <span className="atl-chip" style={{ borderColor: "#cfe6cf", color: "#3a7d44", background: "#eef6ee", fontWeight: 600 }}>
                      ● Live
                    </span>
                  )}
                  <StatusChip status={q.status} />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </AtlShell>
  );
}
